// Recovered compiled webpack factory 83011. Edit this function expression; run npm run build.
(e, t, n) => {
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    Object.defineProperty(t, "useMergedRef", {
      enumerable: !0,
      get: function () {
        return u;
      },
    }));
  let r = n(12115);
  function u(e, t) {
    let n = (0, r.useRef)(null),
      u = (0, r.useRef)(null);
    return (0, r.useCallback)(
      (r) => {
        if (null === r) {
          let e = n.current;
          e && ((n.current = null), e());
          let t = u.current;
          t && ((u.current = null), t());
        } else (e && (n.current = o(e, r)), t && (u.current = o(t, r)));
      },
      [e, t],
    );
  }
  function o(e, t) {
    if ("function" != typeof e)
      return (
        (e.current = t),
        () => {
          e.current = null;
        }
      );
    {
      let n = e(t);
      return "function" == typeof n ? n : () => e(null);
    }
  }
  ("function" == typeof t.default || ("object" == typeof t.default && null !== t.default)) &&
    void 0 === t.default.__esModule &&
    (Object.defineProperty(t.default, "__esModule", { value: !0 }),
    Object.assign(t.default, t),
    (e.exports = t.default));
}
